// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.create-container[data-v-f9fc515e] {\n  background:#f5f7f9;\n  padding: 20px;\n  min-height: 100%;\n}\n.create-title[data-v-f9fc515e] {\n  font-size: 20px;\n  font-weight: bold;\n  color:#000;\n}\n.steps-all[data-v-f9fc515e] {\n  background:#fff;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
